import Constants from './lib/constants';

document.addEventListener("DOMContentLoaded", () => {

    $$("#year").text((new Date()).getFullYear().toString());

    $$(Constants.HAMBURGER_SELECTOR).on("click", () => {
        $$(Constants.NAVLINKS_SELECTOR).toggleClass("open");
    });

    window.onscroll = () => {
        let scrollPos = window.pageYOffset;
        if (scrollPos > 27) {
            $$("#main_content").css("margin-top", "147px");
            $$("header").addClass("sticky");
        } else {
            $$("#main_content").css("margin-top", "0");
            $$("header").removeClass("sticky");
        }
    }
    /*$$(Constants.ARROW_DOWN_SELECTOR).on("click", (e)=> {
        let closest = e.target.data("closest");
        // find the nearest parent .sadrzaj-menu and toggle the 'open' class on its <ul>
        $(this).toggleClass('open');
        $(this).parent().toggleClass('open');
        $(this)
            .closest(closest)
            .find('ul')
            .toggleClass('open');
    });
*/
    $$(Constants.CONTENT_OPENER_SELECTOR).on("click", function (e) {
        const $opener = $$(e.currentTarget);
        let page = $opener.data('page');
        const $item = $opener.closest(Constants.CONTENT_OPENER_SELECTOR);
        const $img = $opener.find('span');
        const $text = $item.find(Constants.CONTENT_OPENER_CONTENT_TITLE_SELECTOR);
        const $page = $item.find(Constants.CONTENT_OPENER_CONTENT_CONTENT_SELECTOR);
        const $subitems = $$("#page" + page);

        $opener.toggleClass('open');
        $text.toggleClass('open');
        $page.toggleClass('open');
        if ($subitems.defined()) {
            $subitems.toggleClass('open');
        }
        const currentOpen = $opener.hasClass('open');
        $img.text(currentOpen ? '-' : '+');
    });


    const mfs = document.getElementById('make_full_screen');
    if (mfs) {
        mfs.addEventListener('click', (e) => {
            const img = document.getElementById('pdf_image');
            const reader = document.getElementById('pdfReader');
            reader.style.aspectRatio = "none";
            reader.style.height = "100%";
            e.preventDefault();
            goFullscreen(img);
        });
        console.log("Fullscreen button found");

    } else {
        console.log("Fullscreen button not found");
    }


    const target = $$('.prelistavanje-content');
    if (target.defined()) {
        let top = 100;
        if (window.innerWidth < 567) {
            top = 100;
        }
        const scrollPos = target.offset().top - top;
        window.scrollTo({top: scrollPos, behavior: 'smooth'});
    }
    $$('.collapsible-arrow').on("click", function (e) {
        const $opener = $$(e.currentTarget);
        const $div = $opener.element.closest('.collapsible');
        $div.classList.toggle('collapsed');
    });
    $$('.collapsible-zakon').on("click", function (e) {
        const $opener = $$(e.currentTarget);
        const $div = $opener.element.closest('.collapsible');
        $div.classList.toggle('collapsed');
        let parent = $div.parentElement;
        let realparent = parent.parentElement;
        let nextdiv = realparent.nextElementSibling;
        nextdiv.classList.toggle('show');
    });

    const boxes = document.querySelectorAll('.relations-box');
    const popovers = document.querySelectorAll('.relations-popover');

    boxes.forEach(box => {
        box.addEventListener('click', (e) => {
            e.stopPropagation();
            console.log(box.dataset.type);
            const type = box.dataset.type;

            popovers.forEach(p => p.classList.remove('active'));

            const popover = document.querySelector(`.relations-popover[data-type="${type}"]`);

            const rect = box.getBoundingClientRect();
            const parentRect = box.closest('.rel-content').getBoundingClientRect();

            const offsetTop = rect.top - parentRect.top;

            popover.style.top = offsetTop + 'px';
            popover.classList.add('active');
        });
    });

    document.addEventListener('click', () => {
        popovers.forEach(p => p.classList.remove('active'));
    });

    document.querySelectorAll("table.tatic-table-stats").forEach(function (table) {

        // Skip if already wrapped
        if (table.parentElement.classList.contains("tatic-table-wrapper")) {
            return;
        }

        const wrapper = document.createElement("div");
        wrapper.className = "tatic-table-wrapper";

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });

    document.querySelectorAll('.tatic-table-wrapper').forEach(wrapper => {
        wrapper.addEventListener('scroll', function () {
            if (this.scrollLeft > 0) {
                this.classList.add('scrolled');
            } else {
                this.classList.remove('scrolled');
            }
        });
    });

})

function goFullscreen(element) {
    if (element.requestFullscreen) {
        element.requestFullscreen();
        console.log("fullscreen");
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(); // Safari
    } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen(); // IE11
    }
}

function goToPage(page, oblast) {
    const iframe = document.getElementById('pdfReader');
    // preserve existing src, just change hash
    iframe.src = iframe.src.replace(/#.*$/, '') + '#page=' + page;

    const target = $$('.prelistavanje-content');
    if (target.defined()) {
        let top = 100;
        if (window.innerWidth < 567) {
            top = 100;
        }
        const scrollPos = target.offset().top - top;
        window.scrollTo({top: scrollPos, behavior: 'smooth'});
    }
    if (oblast !== undefined) {
        $$(".podnaslovcici").css("display", "none");
        $$("#casopispodnaslov" + oblast).css("display", "block");
        $$("#povezaniartikli" + oblast).css("display", "block");
        Net.fetch('/api/casopisi/viewlog', {
            method: "GET",
            query: {id: oblast, fn: 'viewlog'},
        }).then(() => {
        });
    }
}

function pdfprint(url) {
    document.documentElement.style.cursor = 'wait';
    setTimeout(function () {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.onload = function () {
            document.documentElement.style.cursor = 'default';
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };
    }, 100);
}

window.goToPage = goToPage;
window.pdfprint = pdfprint;